import { usePutSegmentStatisticByTypeQuery } from "@tiny/api";
import { useTheme } from "@tiny/components";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

export function useSegmentsStatistics() {
  const theme = useTheme();

  const { mdUp, lgUp } = useBreakpoints();

  const { data, refetch, isLoading } = usePutSegmentStatisticByTypeQuery({
    types: ["CUSTOM", "PREDEFINED_RECOMMENDED", "PREDEFINED_LIBRARY"],
  });

  useRefreshRegister(async () => {
    await refetch();
  });

  const totalCustom = data?.countByType?.["CUSTOM"];

  const totalPredefined =
    (data?.countByType?.["PREDEFINED_RECOMMENDED"] || 0) +
    (data?.countByType?.["PREDEFINED_LIBRARY"] || 0);

  return {
    theme,
    mdUp,
    lgUp,
    totalCustom,
    isLoading,
    totalPredefined,
  };
}
